var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.1494 7.21805C25.5629 6.62013 24.8667 6.14581 24.1003 5.8222C23.334 5.49859 22.5126 5.33203 21.6831 5.33203C20.8535 5.33203 20.0321 5.49859 19.2658 5.8222C18.4994 6.14581 17.8032 6.62013 17.2167 7.21805L15.9997 8.45837L14.7826 7.21805C13.5981 6.01085 11.9915 5.33266 10.3163 5.33266C8.64114 5.33266 7.03455 6.01085 5.85001 7.21805C4.66547 8.42525 4 10.0626 4 11.7698C4 13.477 4.66547 15.1143 5.85001 16.3215L7.06705 17.5619L15.9997 26.6654L24.9323 17.5619L26.1494 16.3215C26.7361 15.7239 27.2015 15.0143 27.519 14.2333C27.8366 13.4523 28 12.6152 28 11.7698C28 10.9244 27.8366 10.0873 27.519 9.30629C27.2015 8.52529 26.7361 7.8157 26.1494 7.21805V7.21805Z",
    stroke: "#C32B22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f2ff345ecf1b70f8ca53d30c2ab9097e.svg";
export { ForwardRef as ReactComponent };